import React from "react";
import styled from "styled-components";

import powered from "./poweredby-gr.png";
import Svg from "../Svg/Svg";

const LinksSection = styled.section`
  background-color: #0a1936;
  color: #ffffff;
  padding-top: ${(props) => (props.allowSubscriptions ? "70px" : "0")};
  padding-bottom: 80px;
  text-align: center;
`;

const Img = styled.img`
  margin: 0 0 5px 0;
`;

const ExtLink = styled.a`
  color: rgb(255, 255, 255);
  display: inline-block;
  margin: 0 10px 40px;
  font-family: freight-sans-pro;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  text-decoration: none;
  text-size-adjust: 100%;
  text-transform: uppercase;
`;

const Para = styled.p`
  margin: 0 0 0;
  color: rgb(57, 80, 116);
  display: block;
  font-family: europa;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
`;

const Links = ({ allowSubscriptions = true }) => {
  return (
    <LinksSection allowSubscriptions={allowSubscriptions}>
      <div>
        <ExtLink href="https://backyourlocal.com.au/contact-us">
          CONTACT US
        </ExtLink>
        <ExtLink href="https://backyourlocal.com.au/faq">FAQ</ExtLink>
      </div>

      {/* <div style={{ marginBottom: "30px" }}>
        <a href="https://www.instagram.com/backyourlocalau" target="_new">
          <Svg name="Instagram" width={36} height={36} />
        </a>
        &nbsp;&nbsp;
        <a href="backyourlocal@grassrootz.com">
          <Svg name="Email" width={36} height={36} />
        </a>
      </div> */}

      <a href="https://grassrootz.com" target="_new">
        <Img src={powered} alt="Powered by Grassrootz" />
      </a>

      <Para>Copyright Back Your Local 2020</Para>
    </LinksSection>
  );
};

export default Links;
